import { render, staticRenderFns } from "./Flickr.vue?vue&type=template&id=bcbceea6&scoped=true&"
import script from "./Flickr.vue?vue&type=script&lang=js&"
export * from "./Flickr.vue?vue&type=script&lang=js&"
import style0 from "./Flickr.vue?vue&type=style&index=0&id=bcbceea6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcbceea6",
  null
  
)

export default component.exports